import React, { useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Stack, Typography } from "@mui/material";
import { ASSETS } from "../../utils/config";
import { useSubmitFeedback } from "../../services/mutations";
import { handleFileUpload } from "../../utils/fileUpload";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "../Button";

const imageTypes = ["png", "jpg", "jpeg"];

const videoTypes = ["mp4", "mkv", "mov", "avi", "flv", "mpeg"];

// gordon-0904-over-limit-upload-must-block-REOPEN — every other upload
// surface in the app enforces this same 50MB cap client-side (see
// MediaLibrary/upload.logic.js, SegmentBuilder/Shared/UploadMedia/validation.js,
// BlockEditorPane/editors/imageUpload.js); this modal was the one caller of
// utils/fileUpload.js#handleFileUpload with no size guard at all, so anything
// under the server's 256MB absolute presign ceiling silently succeeded here.
const MAX_UPLOAD_MB = 50;

const isFileTooLarge = (file) => file.size / 1000000 > MAX_UPLOAD_MB;

function FeedbackModal({ openFeedbackModal, setOpenFeedbackModal }) {
  const [feedbackText, setFeedbackText] = useState("");
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const fileInputRef = useRef(null);

  const submitFeedback = useSubmitFeedback();

  const isMimeTypeAllowed = (type) => {
    if (imageTypes.includes(type)) return "image";
    else if (videoTypes.includes(type)) return "video";
    else return null;
  };

  const handleFileButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (selectedFile) => {
    if (selectedFile) {
      if (isFileTooLarge(selectedFile)) {
        alert(
          `${selectedFile.name} cannot be uploaded. File size cannot be greater than ${MAX_UPLOAD_MB}MB.`
        );
        return;
      }

      const mimeType = selectedFile.name.split(".").pop().toLowerCase();
      const id = Math.floor(Date.now() + Math.random());

      if (isMimeTypeAllowed(mimeType) == "video") {
        const tempVideos = [...videos];
        const temp = { id, file: selectedFile, type: "video", loading: true };
        setVideos([...tempVideos, temp]);
        const result = await handleFileUpload(selectedFile);

        temp["loading"] = false;
        temp["location"] = result.location;

        setVideos([...tempVideos, temp]);
      } else if (isMimeTypeAllowed(mimeType) == "image") {
        const tempImages = [...images];
        const temp = { id, file: selectedFile, type: "image", loading: true };
        setImages([...tempImages, temp]);
        const result = await handleFileUpload(selectedFile);
        temp["loading"] = false;
        temp["location"] = result.location;
        setImages([...tempImages, temp]);
      }
    } else {
      alert("File format not supported!");
    }
  };

  const handleFileRemove = (id) => {
    if (videos.filter((e) => e.id === id)) {
      setVideos(videos.filter((file) => file.id !== id));
    }
    if (images.filter((e) => e.id === id)) {
      setImages(images.filter((file) => file.id !== id));
    }
  };

  const handleSumit = async () => {
    if (feedbackText) {
      setLoading(true);
      if (images.length) {
        var imageLocations = images.map((result) => result.location);
      }

      if (videos.length) {
        var videoLocations = videos.map((result) => result.location);
      }

      const payload = {
        title: "",
        message: feedbackText,
        images: imageLocations,
        videos: videoLocations,
      };
      submitFeedback.mutate(payload, {
        onSuccess: (res) => {
          setLoading(false);
          setSubmitted(true);
        },
        onError: (err) => {
          console.log("error: " + err.response.data.message);
          setLoading(false);
        },
      });
    }
  };

  const onClose = () => {
    setFeedbackText("");
    setImages([]);
    setVideos([]);

    setSubmitted(false);
    setOpenFeedbackModal(false);
  };

  return (
    <Modal
      open={openFeedbackModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "35vw",
          height: "440px",
          bgcolor: "background.paper",
          boxShadow: 24,
          cursor: "pointer",
          overflow: "hidden",
          padding: 3,
          borderRadius: 2,
          minWidth: 400,
        }}
      >
        {submitted ? (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "30vw",
                backgroundColor: "white",
                padding: 20,
                borderRadius: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                style={{
                  fontSize: "14px",
                  fontFamily: "DM Sans",
                  lineHeight: "20px",
                  fontWeight: "600",
                  color: "#123051",

                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                Thank you for your feedback! It's Wheely appreciated 😉
              </Typography>
              <Button
                onClick={onClose}
                style={{ width: 100, height: 30, fontSize: 12 }}
              >
                Close
              </Button>
            </div>
          </div>
        ) : null}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px",
          }}
        >
          <Stack
            display={"flex"}
            justifyContent={"flex-start"}
            flexDirection={"row"}
            alignItems={"center"}
          >
            <img
              alt="feedbackicon"
              src={ASSETS.feedback2}
              style={{ height: "24px", width: "24px" }}
            />

            <Typography
              variant="h6"
              style={{
                fontSize: "15px",
                fontFamily: "DM Sans",
                lineHeight: "20px",
                fontWeight: "600",
                color: "#123051",
                marginLeft: "3px",
                wordWrap: "break-word",
              }}
            >
              Feedback
            </Typography>
          </Stack>
          <CloseIcon style={{ color: "#123051" }} onClick={onClose} />
        </div>

        <Typography
          variant="h6"
          style={{
            fontSize: "10px",
            fontFamily: "DM Sans",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#565556",
          }}
        >
          Let us know about any bugs or issues you encounter. We welcome bug
          reports anytime you spot one. Please share your thoughts on features
          you enjoy, find confusing, or wish we included!
        </Typography>

        <Stack>
          <Stack
            style={{
              backgroundColor: "#F6F7F9",
              height: "240px",
              border: "0.2px solid #E1E1E1",
              borderRadius: 5,
              marginTop: 5,
            }}
          >
            <textarea
              onChange={(e) => setFeedbackText(e.target.value)}
              name=""
              defaultValue=""
              value={feedbackText}
              placeholder="Your Feedback"
              style={{
                resize: "none",
                backgroundColor: "#F6F7F9",
                fontFamily: "DM Sans",
                fontSize: "10px",
                height: [...images, ...videos].length ? "120px" : "175px",
                outline: "none",
                border: "none",

                padding: 15,

                // width: "70%",
              }}
            />
            {[...images, ...videos].length ? (
              <Box
                style={{
                  backgroundColor: "white",
                  height: 50,
                  width: "30vw",
                  margin: "auto",
                  marginBottom: 10,
                  borderRadius: 5,
                  display: "flex",
                  flexWrap: "wrap",

                  overflowY: "auto",
                }}
              >
                {[...images, ...videos].map((file) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      backgroundColor: "#F6F7F9",
                      width: 120,
                      height: 25,
                      borderRadius: 20,
                      justifyContent: "space-between",
                      borderColor: "#BBBBBB",
                      margin: 5,
                      padding: "5px 8px",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <img
                        alt="arrayImgs"
                        src={file.type == "image" ? ASSETS.img : ASSETS.video}
                        style={{ width: 12, height: 12, marginRight: 5 }}
                      />
                      <Typography
                        style={{
                          fontSize: 10,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 70,
                        }}
                      >
                        {file?.file?.name}
                      </Typography>
                    </Box>
                    {file.loading ? (
                      <CircularProgress size={12} />
                    ) : (
                      <CloseIcon
                        onClick={() => handleFileRemove(file.id)}
                        style={{ width: 12, height: 12 }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            ) : null}
          </Stack>

          <Stack
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            // justifyContent={"flex-between"}
            alignItems={"center"}
            style={{ marginTop: "15px" }}
          >
            <Button
              onClick={handleFileButtonClick}
              style={{
                backgroundColor: "#F6F7F9",
                color: "#565556",
                width: "130px",
                height: 30,
                fontSize: 12,
              }}
            >
              <img
                src={ASSETS.AttachIcon}
                alt="attachIcon"
                style={{ width: 15, marginRight: 5 }}
              />
              Attach Media
            </Button>
            <input
              type="file"
              accept="image/*,video/*"
              ref={fileInputRef}
              data-testid="feedback-attachment-input"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e.target.files[0])}
            />

            <Button
              onClick={handleSumit}
              isLoading={loading}
              style={{
                width: "150px",
                height: 30,
                fontSize: 12,
              }}
            >
              Send
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

export default FeedbackModal;
